export default __webpack_public_path__ + "static/media/1897.d9a876ce.png";